/**
 * @brief 이용약관 modal
 * @details
 * @author hyekyoungKang
 * @date 2024-08-19
 * @version 0.0.1
 */

import React from "react";
import styles from "./TermsServiceModal.module.scss";
import CloseSvg from "./../../assets/images/Close.svg";
const TermsServiceModal = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container__title}>
        <span className={styles.container__titleTxt}>스마트워크 이용약관</span>
        <CloseSvg
          className={styles.container__title_icon}
          width="24"
          height="24"
          fill=" #555a5f"
        />
      </div>
      <div className={styles.container__content}>
        <div className={styles.container__content_inner}>
          <ul className={styles.container__infoList}>
            <li>
              제 1 조 (목적)<br></br>이 약관은 스마트워크 (이하 “스마트워크”라
              한다)에서 운영하는 사이트에서 서비스를 이용함에 있어 제공자인
              스마트워크와 고객 간의 권리, 의무 및 제반 사항을 정함을 그
              목적으로 합니다.
            </li>
            <li>
              제 2 조 (용어의 정의)<br></br>① 이 약관에서 사용하는 용어의 정의는
              다음 각호와 같습니다.<br></br> 1. “회원”이라 함은 스마트워크 회원
              가입 절차를 통해 스마트워크 회원으로 등록한 자를 말합니다.
              <br></br>② 전항에 정의되지 아니한 용어는 스마트워크의 서비스 안내
              또는 상관례에 따라 해석됩니다.
            </li>
            <li>
              제 3 조 (약관 등의 개시와 개정)<br></br> ① 스마트워크는 본 약관의
              내용을 서비스의 화면에 게시하거나 기타 방법으로 공지합니다.
              <br></br> ② 스마트워크는 필요한 경우 관련 법령을 위배하지 않는
              범위 내에서 본 약관을 개정할 수 있습니다.<br></br> ③ 스마트워크가
              본 약관을 개정하는 경우에는 개정사유 및 적용일자를 명시하지 않아도
              자동으로 적용됩니다.<br></br> ④ 스마트워크가 전항에 따라 회원에게
              공지하면서 적용일 이내 회원에게 의사표시를 하지 않으면 승인한
              것으로 본다는 뜻을 명확하게 고지하였음에도 의사표시가 없는
              경우에는 변경된 약관을 승인한 것으로 봅니다. 회원이 개정약관에
              동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.<br></br>{" "}
              ⑤ 스마트워크는 각 서비스에 따른 개별약관 및 운영정책을 정할 수
              있으며 회원은 이를 준수하여야 합니다. <br></br>⑥ 본 약관에서
              정하지 아니한 사항에 대해서는 관계법령 및 상관례에 따라
              적용합니다.
            </li>
            <li>
              제 4 조 (이용계약의 성립) <br></br>① 이용계약은 서비스를
              이용하고자 하는 자가 약관에 동의하고 서비스 운영에 필요한 정보와
              서비스이용료를 지급한 후 서비스를 신청하면 스마트워크가 이를
              심사하여 승낙함으로써 성립합니다.<br></br> ② 스마트워크는 다음 각
              호에 해당하는 사유가 있는 경우 이용계약 신청을 승낙하지 아니할 수
              있습니다. <br></br>1. 필요한 정보 및 서류를 누락, 오기하거나
              제출하지 아니한 경우 <br></br>2. 스마트워크가 제공하는 일체의
              서비스에서 계약위반 이력이 있거나 잔존하는 미납금액이 있는 경우{" "}
              <br></br>3. 미성년자가 법정대리인의 동의를 얻지 아니하고 신청한
              경우 <br></br>4. 이용자의 귀책사유로 인하여 승인이 불가능한 경우{" "}
              <br></br>5. 기타 스마트워크의 운영정책에 부합하지 아니하는 경우
              <br></br> ③ 스마트워크는 다음 각 호에 해당하는 경우 이용계약의
              신청을 유보할 수 있습니다. <br></br>1. 천재지변, 전쟁 등 국가
              초유의 비상사태 또는 그에 준하는 경우 <br></br>2. 업무수행에
              지장이 초래할 정도의 지극히 곤란한 사유가 있는 경우 <br></br>3.
              품질 유지가 곤란하거나 필요한 설비나 인력이 부족한 경우 <br></br>
              4. 기타 스마트워크의 기술적/관리적 사정으로 이용계약의 승낙이
              곤란한 경우 <br></br>⑤ 스마트워크는 이용계약의 승낙 후 본 조
              제3항, 제4항에 해당하는 경우 제6조에 따른 사전 통지 후 이용계약의
              승낙을 철회할 수 있습니다.
            </li>{" "}
            <li>
              제 5조 (개인정보보호)<br></br> 스마트워크는 개인정보보호법 등
              개인정보 관련법령 및 『개인정보 안전성 확보조치 기준』 등에 따라
              개인정보 안전성 확보에 필요한 관리적 ∙ 기술적 조치를 취하며
              스마트워크의 개인정보처리방침에 따라 이용자의 개인정보를
              보호합니다.
            </li>{" "}
            <li>
                제 6 조 (회원에 대한 통지)<br></br> 스마트워크가 회원에 대하여
              통지를 하는 경우 이 약관에 별도의 규정이 없는 한 회원이 제공한
              전자우편, SMS, 유선 등으로 통지합니다. 다만, 스마트워크는 회원
              전체 또는 다수에 대한 통지의 경우 7일 이상 스마트워크의 공지사항
              등에 게시함으로써 본문의 통지를 갈음할 수 있습니다.
            </li>{" "}
            <li>
              제 7 조 (서비스의 구성)<br></br> ① 이 약관에 따라 스마트워크가
              제공하는 상품 및 서비스는 아래와 같으며, 개별 이용조건은
              첨부문서에 따릅니다. <br></br>1. 회의실 <br></br>2. 모두의 라운지
              <br></br>3. 독립형 상주 사무실 <br></br>4. 기타 스마트워크가 제공하는
              서비스 <br></br>② 스마트워크는 본 조에 의한 서비스 전부의 중단 시
              제6조에 따라 사전 통지합니다. 다만, 서비스의 일부 변경은 사전통지
              없이 변경할 수 있습니다.
            </li>{" "}
            <li>
              제 8 조 (서비스의 이용)<br></br> ① 본 서비스는 스마트워크가
              제공하는 각 서비스 별 안내페이지 및 가이드 등에 따라 서비스가
              제공됩니다. 서비스의 기본 조건은 첨부문서와 같습니다. <br></br>②
              본 서비스는 스마트워크 또는 스마트워크가 지정한 결제대행사를
              통하여 판매대금 일체가 거래되도록 요구될 수 있습니다.<br></br> ③
              본 서비스는 안정적인 서비스 제공을 위해 사전 통지 후 수시, 정기
              점검을 실시할 수 있으며, 점검에 의해 서비스 일부 또는 전부가
              중단될 수 있습니다.<br></br> ④ 본 서비스는 제3자를 통한 업무
              위탁에 의해 일부 서비스가 제공될 수 있습니다.<br></br> ⑤ 본
              서비스는 개별 이용수칙 등을 정할 수 있으며, 회원은 서비스 이용 시
              이를 준수하여야 합니다. 특히, 다른 회원의 서비스 이용을 방해하거나
              지장을 주는 행위는 서비스 이용이 제한되며, 기 지급된
              서비스이용료는 반환되지 아니합니다.<br></br> ⑥ 본 서비스는 본인에
              한하여 이용이 가능하며, 대리로 서비스를 신청하거나 재 판매하는
              등의 서비스 방식인 경우 서비스 이용이 제한될 수 있습니다.
            </li>
            <li>
              제 9 조 (스마트워크의 권리와 의무)<br></br> ① 스마트워크는
              안정적인 서비스 제공을 위해 성실하게 서비스를 제공합니다.<br></br>{" "}
              ② 스마트워크는 정기/수시로 서비스 제공을 위한 설비 및 장비 등을
              유지, 보수하고 장애가 발생한 경우 이를 신속하게 수리 또는
              복구하도록 최선을 다합니다.<br></br> ③ 스마트워크는 서비스 이용에
              따른 이용 내역, 매출, 접속자수 등의 관련 정보를 수집하여 통계자료
              등으로 활용할 수 있으며 이를 회원의 서비스 이용에 지원하거나
              스마트워크의 효율적인 서비스 제공을 위해 사용할 수 있습니다.
              <br></br> ④ 스마트워크는 운영과정에서 회원의 예약 변경 또는 취소가
              필요한 경우 2일 전 사전 통지로 이를 변경할 수 있습니다. 다만, 예약
              변경 거부 시 서비스이용료는 전액 환불 처리됩니다.<br></br> ⑤
              스마트워크는 다양한 정책 및 기준을 정하여 회원에게 이에 대한
              준수를 요구할 수 있습니다.
            </li>
            <li>
              제 10 조 (회원의 권리와 의무)<br></br> ① 회원은 일정 조건 하에
              스마트워크가 제공하는 서비스를 이용할 수 있는 권한을 가집니다.
              <br></br> ② 회원은 스마트워크로부터 부여를 받은 아이디 및
              비밀번호가 유출되지 아니하도록 관리책임을 부담하며 스마트워크의
              서면동의 없이 타인에게 양도하거나 대여하지 아니합니다.<br></br> ③
              회원은 반드시 스마트워크에 제공한 전자우편, 연락처 등의 정보를
              최신의 정보로 유지하여야 합니다. 만일, 이를 게을리하여
              스마트워크의 통지가 미 도달한 경우 그로 인해 발생한 회원의 손해에
              대하여 스마트워크는 책임을 부담하지 아니합니다.<br></br> ④ 회원은
              서비스를 이용함에 있어 선관주의의무를 다하여야 합니다. 서비스 내
              비치된 시설물 및 장비 등을 손망실한 경우에는 동일한 신품을
              기준으로 배상하여야 합니다.
            </li>
            <li>
              제 11 조 (정보제공 및 광고의 게재)<br></br> ① 스마트워크는
              홈페이지 내 공지사항을 통하여 서비스 이용에 필요한 안내 및 정책
              등을 제공합니다. <br></br>② 스마트워크는 회원의 별도의 동의 하에
              다양한 정보를 이메일 또는 SMS를 통하여 제공할 수 있습니다. 다만,
              거래관련 정보 및 고객문의 등에 관한 답변은 동의를 요하지
              아니합니다.<br></br> ③ 스마트워크는 서비스 운영과 관련하여
              서비스화면, 홈페이지 등에 다양한 광고를 게재할 수 있습니다.
              <br></br> ④ 회원은 스마트워크가 제공하는 서비스와 관련한 게시물
              또는 기타 정보, 광고물을 임의로 변경하거나 수정하지 아니하며, 이에
              대한 노출을 방해하는 프로그램 등을 설치하지 아니합니다.<br></br> ⑤
              스마트워크는 홈페이지 내 게재되는 다양한 정보 및 광고 중에
              스마트워크가 직접 서비스하지 아니하는 부분에 대해서는 일반적인
              광고매체의 역할을 수행하는 것일 뿐 이를 신뢰하거나 그로 인하여
              발생된 거래관계에 대하여 어떠한 보증 및 책임도 부담하지
              아니합니다.
            </li>
            <li>
              제 12 조 (지적재산권의 귀속 및 침해금지)<br></br> ① 스마트워크가
              제공하는 서비스 등에 관한 저작권 및 기타 지식재산권은 스마트워크에
              귀속합니다. <br></br>② 스마트워크의 서비스 이용과 관련하여 회원이
              작성한 게시물 또는 사진 등을 활용하여 홈페이지 또는 다른 매체를
              통해 서비스를 홍보하는 목적으로 사용할 수 있습니다.<br></br> ③
              회원은 스마트워크가 제공하는 정보나 기술, 자료, 시스템, 서비스
              등을 스마트워크의 사전허가 없이 복제, 송신, 출판, 배포, 방송, 판매
              및 기타 이에 준하는 행위를 하지 아니하며 스마트워크가 허가하지
              아니한 영리목적으로 이용하지 아니합니다.
            </li>
            <li>
              제 13 조 (서비스의 중단) <br></br>① 스마트워크는 다음 각 호에
              해당하는 경우 사전 통지 없이 서비스의 제공을 중단할 수 있습니다.
              <br></br>1. 설비의 보수 등을 위하여 긴급하게 점검이 필요한 경우{" "}
              <br></br>2. 정전, 설비의 장애 또는 이용의 폭주 등 정상적인 이용에
              지장이 있는 경우
              <br></br>3. 디스크 또는 시스템 장애, OS 등 버그 등 사전에 인지할
              수 없는 사유로 장애가 있는 경우 <br></br>4. 외부 통신스마트워크,
              전력스마트워크, 기간통신사업자 등의 서비스에 장애가 있는 경우{" "}
              <br></br>5. 분산서비스거부(DDos) 등 외부적 침입이 있거나 예견되는
              경우<br></br> 6. 컴퓨터 바이러스, 악성코드 등을 유포하거나 해킹,
              서버 공격 등에 이용되는 경우 <br></br>7. 천재지변, 국가비상사태
              등의 사유로 인하여 서비스의 제공이 불가한 경우<br></br> 8. 기타
              스마트워크의 운영상 제공할 수 없는 상당한 사유가 발생한 경우
              <br></br> ② 스마트워크는 본 조에 따른 서비스 중단으로 인한 회원의
              손해에 대해 책임을 부담하지 아니합니다.
            </li>
            <li>
              제 14 조 (이용제한)<br></br> ① 스마트워크는 다음 각 호의 사유에
              해당하는 경우 사전 통지 후 서비스 이용을 제한할 수 있습니다.
              <br></br> 1. 등록한 정보와 실제 정보가 상이한 경우<br></br> 2.
              회원이 제공한 연락처로 연락을 시도하였으나 연락이 되지 아니하는
              경우(1일 간격 총 2회 이상) <br></br>3. 이 약관에 따른 권리·의무를
              타인에게 양도하거나 담보로 제공하는 경우 <br></br>4. 타인의 명예를
              훼손하거나 모욕하는 행위를 하는 경우<br></br> 5. 서비스 이용료의
              지급을 하지 아니한 경우 <br></br>6. 개별 이용 수칙 등 스마트워크가
              제시한 정책 및 조건을 준수하지 아니한 경우 <br></br>7. 이 약관의
              의무를 위반하는 경우 <br></br>② 본 조에 의한 이용제한으로 회원에게
              손해가 발생한 경우 스마트워크는 이에 대한 책임을 부담하지
              아니합니다.
            </li>
            <li>
              제 15 조 (계약의 해지) <br></br>① 회원은 이용계약의 종료 의사를
              스마트워크에 전달할 수 있으며, 스마트워크는 특별한 사정이 없는 한
              회원이 요청한 해지일로부터 빠른 시일 내에 이용계약을 종료합니다.
              다만, 기 지급된 서비스이용료 등은 회원약관 계약서에 따라
              반환됩니다. <br></br>② 스마트워크는 사업종목의 전환, 사업의 포기,
              사업양도, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는
              경우 30일 전 사전 통지로 계약을 해지할 수 있습니다. 이 경우 서비스
              해지로 인하여 발생한 회원의 손해에 대해서는 책임을 부담하지
              아니합니다.<br></br> ③ 스마트워크는 회원이 다음 각 호에 해당하는
              경우 사전통지로 계약을 해지할 수 있습니다.<br></br> 1. 각 국가의
              유관기관으로부터 계약의 해지에 준하는 처분을 받은 경우<br></br> 2.
              공서양속에 위배되는 행위를 한 경우<br></br> 3. 당해 연도 2회 이상
              이용제한을 당한 경우 <br></br>4. 스마트워크가 판매하는 서비스와
              유사한 서비스를 제공하는 다른 경쟁사의 서비스를 소개, 판매하거나
              유도하는 등의 사전에 스마트워크의 허가를 받지 않은 영업활동을
              하거나 이에 준하는 행위를 하는 경우 <br></br>5. 다른 회원 또는
              스마트워크의 업무를 방해하는 행위를 하는 경우
            </li>
            <li>
              제 16 조 (손해배상)<br></br> 스마트워크와 회원은 자신의 귀책사유로
              이 약관을 위반하여 상대방에게 손해가 발생한 경우 그 손해에 대하여
              배상책임을 부담합니다. 다만, 스마트워크는 각 서비스 별
              서비스이용료를 그 한도로 회원의 손해를 배상합니다.
            </li>
            <li>
              제 17 조 (면책)<br></br> ① 스마트워크는 서비스를 이용하여 기대하는
              수익 또는 서비스와 관련하여 얻은 정보 및 자료로 인해 발생한 손해에
              대하여 책임을 부담하지 아니합니다.<br></br> ② 스마트워크는 무료로
              제공하는 서비스와 관련하여 관련법에 특별한 규정이 없는 한 책임을
              부담하지 아니합니다.
            </li>
            <li>
              제 18 조 (준거법 및 분쟁의 해결)<br></br> ① 이 약관으로부터 발생한
              모든 분쟁과 관련하여 대한민국 법이 적용되며 이에 의하여
              해석됩니다.<br></br> ② 이 약관과 관련된 분쟁이 발생한 경우 양
              당사자는 상호 합의를 통하여 이를 원만히 해결합니다. 그럼에도
              불구하고 해결되지 아니한 경우에는 민사소송법 상의 관할법원에
              제소합니다.
            </li>
            <li>
              제 19 조 (약관 외 준칙) <br></br>이 약관에 명시되지 아니한 사항은
              스마트워크의 서비스 안내 및 관계법령, 상관례에 따릅니다.
            </li>
            <li>
              첨부. 각 서비스 별 기본조건 <br></br>[부칙] 본 약관은 2024년 08월
              19일부터 시행합니다. <br></br>첨부. 각 서비스 별 기본 조건{" "}
              <br></br>①  회의실<br></br> 1. 서비스이용료 :<br></br>    1) 기본
              이용료 : 서비스 안내에 따름 <br></br>    - 소회의실 최대 4인
              <br></br>    - 중회의실 최대 7인<br></br>    &nbsp;- 대회의실 최대
              10명까지 이용 가능 <br></br>2. 미이용 잔여 시간에 대한
              서비스이용료 환불 불가 <br></br>3. 이용조건 <br></br>  1) 예약
              가능 시간 : 평일 09:00 ~ 18:00 <br></br>   ※ 토요일, 일요일,
              공휴일 예약 불가  <br></br> &nbsp; 2) 카드결제, 선불 지급 시 이용
              가능 <br></br>4. 취소 및 환불조건  <br></br> &nbsp; 1)회원약관에
              따름. 단, 최소 계약 기간 내 환불 불가  <br></br>
              <br></br> ② 모두의 라운지 <br></br>1. 서비스 이용료 :<br></br>{" "}
              &nbsp;1)기본이용료 : 서비스 안내에 따름 <br></br>2. 이용조건
              <br></br>  1) 이용 가능 시간 : 24시간 운영 <br></br>  2) 선불 지급
              시 이용 가능 <br></br>
              <br></br>③ 독립형 상주 사무실<br></br> 1. 서비스 이용료   1) 기본
              이용료 : 서비스 안내에 따름 <br></br>2. 이용조건
              <br></br>   1) 이용 가능 시간 : 24시간 운영<br></br>   2) 투어
              예약 가능 시간 : 평일 09시~18시 <br></br>3. 취소 및 환불조건
              <br></br>   1) 회원약관에 따름. 단, 최소 계약 기간 내 환불 불가{" "}
              <br></br> <br></br>④기타 스마트워크가 제공하는 서비스
              <br></br>
              <br></br>※ &nbsp; &nbsp;상기 각 서비스 별 기본 조건 외 서비스는
              사이트 내 서비스 안내에 따름.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsServiceModal;
